/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_Point_3Inputs */

const en_backstage_point_3 = /** @type {(inputs: Backstage_Point_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linesheets, purchase orders, sales orders and stock in one grid`)
};

/**
* | output |
* | --- |
* | "Linesheets, purchase orders, sales orders and stock in one grid" |
*
* @param {Backstage_Point_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_point_3 = /** @type {((inputs?: Backstage_Point_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_Point_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_point_3(inputs)
});